export default __webpack_public_path__ + "static/Poppins-ExtraBold-01849ee091e1762a5dd58aa1606242c6.ttf";